import React, { memo } from "react";
import { HStack, Text, Highlight, Circle } from "@chakra-ui/react";
import colors from "app/colors";
import { getDistributionGroupMention } from "modules/utils/Functions";
import {
  ArchivedPeopleOutlineIcon,
  PeopleOutlineIcon,
  ExternalIcon,
} from "modules/icons";
import { InternalAdminDistributionGroupFragment } from "gql/graphql";

interface IProps {
  distributionGroup?: InternalAdminDistributionGroupFragment;
  search: string;
}

const InternalAdminDistributionGroupOptionLabel = ({
  distributionGroup,
  search,
}: IProps) => {
  if (!distributionGroup) return null;
  if (distributionGroup.active) {
    return (
      <HStack color={colors.blue}>
        <Circle backgroundColor={colors.blueLighter}>
          <PeopleOutlineIcon boxSize={5} fill={colors.blue} />
        </Circle>
        <Text noOfLines={1} fontSize={12}>
          <Highlight
            query={search}
            styles={{
              fontWeight: 700,
              color: colors.blue,
              margin: "0 !important",
            }}
          >
            {getDistributionGroupMention(distributionGroup)}
          </Highlight>
        </Text>
        {distributionGroup.emailUserIdList.length > 0 && (
          <ExternalIcon fill={colors.transparent} />
        )}
      </HStack>
    );
  }
  return (
    <HStack color={colors.grayMain}>
      <ArchivedPeopleOutlineIcon boxSize={5} />
      <Text noOfLines={1} fontSize={12} fontWeight={500} fontStyle="italic">
        <Highlight
          query={search}
          styles={{
            fontWeight: 700,
            color: colors.gray80,
            margin: "0 !important",
          }}
        >
          {getDistributionGroupMention(distributionGroup)}
        </Highlight>
      </Text>
      {distributionGroup.emailUserIdList.length > 0 && (
        <ExternalIcon fill={colors.transparent} />
      )}
    </HStack>
  );
};

export default memo(InternalAdminDistributionGroupOptionLabel);
